import { ViewModel,View, ObservableArray, DelegatedObservableArrayChangeListenner } from "binder"
import  { MultiSelectorBaseView } from "./multiSelectorBase-view"

export type ElementType = {
    set title(v: string);
    get title(): string;
    set id(v: string);
    get id(): string;
};

export abstract class MultiSelectorBaseViewModel<T extends ElementType> extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<T>();
        this.selectedItems = ObservableArray.create<T>();
        this.selectedItems.addChangeListenner(new DelegatedObservableArrayChangeListenner(this,x=>this.onSelectionChanged([...x])))
        this.refresh();

    }
    GetDefaultView(): View <ViewModel> {
        return new MultiSelectorBaseView();
    }
    public getTypeId(): string {
        return "VM-7511CB3E-5C51-4A1C-8A58-80BD58AA2724"
    }

    public set items(v: ObservableArray<T>) { this._items = v; } public get items(): ObservableArray<T> { return this._items;} private _items: ObservableArray<T>;
    public set selectedItems(v: ObservableArray<T>) { this._selectedItems = v; } public get selectedItems(): ObservableArray<T> { return this._selectedItems;} private _selectedItems: ObservableArray<T>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private selectedIds:string[];

    onSelectionChanged(elements:T[]){};

    async refresh(){
        try {
            this.isLoading = true;
            let result =await this.loadData();
            this.items.update(...result);
            if(this.selectedIds!=null){
                this.selectById(this.selectedIds);                
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    protected abstract loadData():Promise<T[]>; 

    public selectById(id:string[]){
        if(id==null){
            this.selectedIds = [];
            this.selectedItems.clear();
        }else{
            this.selectedIds = [...id];
            this.selectedItems.update(...this.items.filter(x=>this.selectedIds.indexOf(x.id)>-1));
        }
    }

}
